import { useGameStore } from '../../store/gameStore';
import { GameBoard } from '../board/GameBoard';
import { BottomTabBar } from './BottomTabBar';
import { MissionBetPanel } from './MissionBetPanel';
import { MissionDraftPickedSection } from './MissionDraftPickedSection';
import { CurrentRoundMissionStrip } from './CurrentRoundMissionStrip';
import { MissionsMenuDrawer } from './MissionsMenuDrawer';
import { OverviewHint } from './OverviewHint';
import { PhaseBanner } from './PhaseBanner';
import { SettingsDrawer } from './SettingsDrawer';
import { SettlementModal } from './SettlementModal';
import { SetupModal } from './SetupModal';
import { StickyActionBar } from './StickyActionBar';

export function HtmlOverlay() {
  const phase = useGameStore((s) => s.game.phase);
  const cameraMode = useGameStore((s) => s.cameraMode);

  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex flex-col pb-safe pt-safe-top">
      <header className="pointer-events-auto shrink-0 px-4 pt-3">
        <PhaseBanner />
      </header>

      <main className="relative flex min-h-0 flex-1 flex-col">
        <GameBoard />

        {phase === 'setup' && (
          <div className="pointer-events-auto absolute inset-0 flex items-center justify-center px-4">
            <div className="w-full max-w-md">
              <SetupModal />
            </div>
          </div>
        )}
        {phase === 'game_over' && (
          <div className="pointer-events-auto absolute inset-0 flex items-center justify-center px-4">
            <div className="w-full max-w-md">
              <SettlementModal />
            </div>
          </div>
        )}
      </main>

      {cameraMode === 'play' && phase !== 'setup' && phase !== 'game_over' && (
        <section className="pointer-events-auto shrink-0 space-y-2 px-4 pb-2">
          {phase === 'mission_draft' && <MissionDraftPickedSection />}
          <CurrentRoundMissionStrip />
          <MissionBetPanel />
          <StickyActionBar />
        </section>
      )}

      {cameraMode === 'overview' && phase !== 'setup' && (
        <section className="pointer-events-auto shrink-0 px-4 pb-2">
          <OverviewHint />
        </section>
      )}

      <footer className="pointer-events-auto shrink-0 px-4 pb-3">
        <BottomTabBar />
      </footer>

      <SettingsDrawer />
      <MissionsMenuDrawer />
    </div>
  );
}
